export const customBrandOpts = {
    createWishList: {
        lojaanimale: { nomeDaLojinha: () => undefined, linkDaLojinha: true, descricao: true, },
        lojafabula: { nomeDaLojinha: () => undefined, linkDaLojinha: true, descricao: true, },
        lojafarm: { nomeDaLojinha: () => undefined, linkDaLojinha: true, descricao: false, },
        lojaoffpremium: { nomeDaLojinha: () => undefined, linkDaLojinha: true, descricao: true, },
        mariafilo: { nomeDaLojinha: () => undefined, linkDaLojinha: true, descricao: true, },
        lojacrisbarros: {
            nomeDaLojinha: (user: string) => `Curadoria exclusiva por ${user}`,
            linkDaLojinha: false,
            descricao: true,
        },
        null: { nomeDaLojinha: () => undefined, linkDaLojinha: false, descricao: false, },
    },
    EditWishList: {
        lojaanimale: { nomeDaLojinha: () => true, linkDaLojinha: true, descricao: true, },
        lojafabula: { nomeDaLojinha: () => true, linkDaLojinha: true, descricao: true, },
        lojafarm: { nomeDaLojinha: () => true, linkDaLojinha: true, descricao: false, },
        lojaoffpremium: { nomeDaLojinha: () => true, linkDaLojinha: true, descricao: true, },
        mariafilo: { nomeDaLojinha: () => true, linkDaLojinha: true, descricao: true, },
        lojacrisbarros: { nomeDaLojinha: () => false, linkDaLojinha: false, descricao: true, },
        null: { nomeDaLojinha: () => false, linkDaLojinha: false, descricao: false, },
    },
};
